<template>
	<div>
		<img :class="btn_hide==1?'return_btn animate__animated animate__fadeOut':'return_btn circle_lage animate__animated animate__bounceIn'" src="../assets/static/images/jiantou.png" @click="returnHeader()">
	</div>
</template>

<script>
	import { scrollAnimation } from '../utils/js/scrollAnimation.js';
	export default {
	  name: "index",
	  data() {
	    return {
			btn_hide:1
	    };
	  },
	  mounted() {
	   window.addEventListener('scroll', this.returnToTop)
	  },
	methods:{
			//监听页面位置，达到条件执行图标动画
		returnHeader(){
			if(this.btn_hide==1) return;
			const currentY = document.documentElement.scrollTop || document.body.scrollTop
			scrollAnimation(currentY, 0)
		}
	,
		returnToTop() { 
		  var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
		  console.log(scrollTop)
		  if(scrollTop>=800){
			  this.btn_hide=0
		  }
		 else{
			 this.btn_hide=1
		 }
		},
		
	}}
</script>

<style>
	.return_btn{
		width: 5rem;
		height: 5rem;
		position: fixed;
		z-index: 1000;
		bottom: 3rem;
		right: 2rem;
		cursor: pointer;
	}
	.btn_hide{
		display: none;
	}
</style>
